import { TAxisOptions } from '../types/types';
import { colors } from './color';

export const gridLineStyle: TAxisOptions = {
  gridLineDashStyle: 'Solid',
  gridLineColor: colors.lightGrey,
  tickPixelInterval: 80,
};
